import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth.service';
import { PermissionsEnum } from '../../../api/api-reference';

@Component({
  selector: 'app-on-demand-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet],
  templateUrl: './on-demand-menu.component.html',
  styleUrl: './on-demand-menu.component.scss',
})
export class OnDemandMenuComponent {
  public PermissionsEnum = PermissionsEnum;

  constructor(private router: Router, public authService: AuthService) {}
  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
